/**
 * @description 处理无障碍，关怀版的点击事件绑定
 */
export const bindAriaEvent = function () {
    const noBarrierEle = document.querySelector("#no-barrier")
    noBarrierEle?.addEventListener("click", async function (event) {
        try {
            const target = event.target
            const { startAria } = await import("fed_sharedlib/startAria")
            switch (target.id) {
                case "wza":
                    // 执行无障碍相关的逻辑
                    startAria("wza")
                    console.log("无障碍链接被点击")
                    break
                case "ghb":
                    startAria("ghb")
                    // 执行关怀版相关的逻辑
                    console.log("关怀版链接被点击")
                    break
                default:
                    // 其他元素被点击，例如：'.divider'元素
                    console.log("其他元素被点击")
            }
        } catch (e) {
            console.log("federation err ", e)
        }
    })
}
